import { containerTransportGrid_filters } from "./filter";

const containerTransportGrid = {
	...containerTransportGrid_filters
};

export { containerTransportGrid };
